export default "__VITE_ASSET__EVuiY8_A__"